import React from 'react'
import Box from "@material-ui/core/Box";

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
    className?: any;
  }
  
export default function TabPanel(props: TabPanelProps) {
    const { children, value, index, className, ...other } = props;

    return (
        <div
            className={className}
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
        {value === index && (
            <Box>
            <div>{children}</div>
            </Box>
        )}
        </div>
    );
}